import { useState } from 'react';
import PropTypes from 'prop-types';

import { styled } from '@prose-ui/legacy';

import { Button } from 'Components/LegacyButton';
import Spacer from 'Components/Spacer';
import { SupplementsFactsModal } from 'Components/SupplementsFactsModal';
import { Typography } from 'Components/Typography';

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;

  width: 100%;
  margin: auto;
`;

const FactsButton = styled(Button)`
  margin: 0;
  text-transform: initial;
  &:after {
    height: 1px;
  }
`;

const FactsText = styled(Typography)`
  // Necessary otherwise text looks cut on the upper part on safari
  padding-top: 0.2em;

  line-height: 0.8em;
`;

const IngredientSection = ({ children, isSupplement, title }) => {
  const [isSupplementsFactsOpen, setSupplementsFactsOpen] = useState(false);

  return (
    <Wrapper>
      <Typography align="center" variant="mono2">
        {title}
      </Typography>

      {isSupplement && (
        <>
          <Spacer axis="vertical" size={14} />
          <FactsButton
            data-click="supplements-facts"
            data-from="results-ingredients"
            data-testid="supplement-facts"
            onClick={() => setSupplementsFactsOpen(true)}
            variant="underlinedBlack"
          >
            <FactsText align="center" markupName="span" variant="p2">
              View your full supplement facts
            </FactsText>
          </FactsButton>
        </>
      )}

      {isSupplement && (
        <SupplementsFactsModal
          closeModal={() => setSupplementsFactsOpen(false)}
          isModalOpen={isSupplementsFactsOpen}
        />
      )}

      {children}
    </Wrapper>
  );
};

IngredientSection.defaultProps = {
  isSupplement: false,
};

IngredientSection.propTypes = {
  children: PropTypes.node.isRequired,
  isSupplement: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

export default IngredientSection;
